import { render, staticRenderFns } from "./PermissionTreeNode.vue?vue&type=template&id=d81656ac&scoped=true"
import script from "./PermissionTreeNode.vue?vue&type=script&lang=js"
export * from "./PermissionTreeNode.vue?vue&type=script&lang=js"
import style0 from "./PermissionTreeNode.vue?vue&type=style&index=0&id=d81656ac&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_babel-core@7.0.0-bridge.0_@babel+core@7.29._923e00a32cb73abfd4273dbca1fa1c77/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81656ac",
  null
  
)

export default component.exports